import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Card, Image, Tab, Nav } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import api, { getDatiAzienda, getLegalDocument, uploadLegalDocument, updateLegalDocumentContent } from '../services/api';

const LEGAL_DOCUMENT_TYPES = {
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  DIRITTO_DI_RECESSO: 'diritto_di_recesso',
};

// Il form preventivo di modenariversamenti.it raccoglie dati diversi (nome/email/
// telefono/note, non un acquisto) da quelli del negozio: ha una sua informativa,
// mostrata nel tab ModenaRiversamenti invece che tra quelli del negozio sopra.
const LEGAL_DOCUMENT_TYPES_RIVERSAMENTI = {
  PRIVACY_POLICY_RIVERSAMENTI: 'privacy_policy_riversamenti',
};

const TUTTI_I_DOCUMENTI_LEGALI = { ...LEGAL_DOCUMENT_TYPES, ...LEGAL_DOCUMENT_TYPES_RIVERSAMENTI };

const DatiAzienda = () => {
  // ?tab=riversamenti apre direttamente il tab del sito riversamenti, per il
  // collegamento diretto dalla sidebar (voce "Logo e dati azienda").
  const [searchParams] = useSearchParams();
  const tabIniziale = searchParams.get('tab') === 'riversamenti' ? 'riversamenti' : 'modenacinema';

  const [formData, setFormData] = useState({
    denominazione: '',
    indirizzo: '',
    cap: '',
    citta: '',
    provincia: '',
    nazione: '',
    piva: '',
    regImprese: '',
    tel: '',
    cell: '',
    email: '',
    emailOrdini: '',
    emailReclami: '',
    pec: '',
    homePage: '',
    logoUrl: '',
    logoRiversamentiUrl: '',
    fraseDelGiorno: '',
    fraseDelGiornoFont: 'Arial',
    orariApertura: '',
    prossimoNumeroFattura: 1,
    facebookUrl: '',
    instagramUrl: '',
    dataInizioChiusura: '',
    dataFineChiusura: '',
    messaggioChiusura: '',
  });
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  // Logo del sito modenariversamenti.it, separato da quello di ModenaCinema
  const [logoRivFile, setLogoRivFile] = useState(null);
  const [logoRivPreview, setLogoRivPreview] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const [legalDocuments, setLegalDocuments] = useState({
    privacy_policy: { metadata: null, file: null, uploadLoading: false, content: '' },
    terms_and_conditions: { metadata: null, file: null, uploadLoading: false, content: '' },
    diritto_di_recesso: { metadata: null, file: null, uploadLoading: false, content: '' },
    privacy_policy_riversamenti: { metadata: null, file: null, uploadLoading: false, content: '' },
  });

  const fetchLegalDocuments = async () => {
    const STATIC_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    for (const typeKey in TUTTI_I_DOCUMENTI_LEGALI) {
        const documentType = TUTTI_I_DOCUMENTI_LEGALI[typeKey];
        try {
            const response = await getLegalDocument(documentType);
            const metadata = response.data;
            if (metadata.file_path) {
                metadata.file_url_for_display = `${STATIC_URL}/api/uploads/legal_documents/${metadata.file_path.split(/\/|\\/).pop()}`;
            }
            setLegalDocuments(prevDocs => ({
                ...prevDocs,
                [documentType]: { ...prevDocs[documentType], metadata: metadata, content: metadata.content || '' }
            }));
        } catch (error) {
            if (error.response && error.response.status === 404) {
                setLegalDocuments(prevDocs => ({
                    ...prevDocs,
                    [documentType]: { ...prevDocs[documentType], metadata: null, content: '' }
                }));
            } else {
                console.error(`Errore durante il recupero del documento legale ${documentType}:`, error);
            }
        }
    }
  };

  const handleLegalDocContentChange = (documentType, value) => {
    setLegalDocuments(prevDocs => ({
        ...prevDocs,
        [documentType]: { ...prevDocs[documentType], content: value }
    }));
  };

  const handleLegalDocumentContentSave = async (documentType, title) => {
    const docState = legalDocuments[documentType];
    setLegalDocuments(prevDocs => ({ ...prevDocs, [documentType]: { ...docState, uploadLoading: true } }));
    setMessage('');
    setMessageType('');

    try {
        const response = await updateLegalDocumentContent(documentType, title, docState.content);
        const updatedMetadata = response.data;
        if (updatedMetadata.file_path) {
            const STATIC_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            updatedMetadata.file_url_for_display = `${STATIC_URL}/api/uploads/legal_documents/${updatedMetadata.file_path.split(/\/|\\/).pop()}`;
        }
        setLegalDocuments(prevDocs => ({
            ...prevDocs,
            [documentType]: { ...docState, metadata: updatedMetadata, content: updatedMetadata.content || '' }
        }));
        setMessage(`Contenuto per "${title}" salvato con successo!`);
        setMessageType('success');
    } catch (error) {
        console.error(`Errore durante il salvataggio del contenuto per ${title}:`, error);
        setMessage(`Errore durante il salvataggio del contenuto per "${title}".`);
        setMessageType('danger');
    } finally {
        setLegalDocuments(prevDocs => ({ ...prevDocs, [documentType]: { ...docState, uploadLoading: false } }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleRivFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoRivFile(file);
      setLogoRivPreview(URL.createObjectURL(file));
    }
  };

  const handleLegalDocumentFileChange = (documentType, e) => {
    const file = e.target.files[0];
    setLegalDocuments(prevDocs => ({
      ...prevDocs,
      [documentType]: { ...prevDocs[documentType], file: file }
    }));
  };

  const handleLegalDocumentUpload = async (documentType, title) => {
    const docState = legalDocuments[documentType];
    if (!docState.file) {
      alert(`Seleziona un file per il documento ${title}.`);
      return;
    }

    setLegalDocuments(prevDocs => ({ ...prevDocs, [documentType]: { ...docState, uploadLoading: true } }));
    setMessage('');
    setMessageType('');

    try {
      const response = await uploadLegalDocument(documentType, title, docState.file);
      const uploadedMetadata = response.data;
      const STATIC_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      if (uploadedMetadata.file_path) {
          uploadedMetadata.file_url_for_display = `${STATIC_URL}/api/uploads/legal_documents/${uploadedMetadata.file_path.split(/\/|\\/).pop()}`;
      }
      setLegalDocuments(prevDocs => ({
        ...prevDocs,
        [documentType]: { ...prevDocs[documentType], metadata: uploadedMetadata, file: null, content: '' } // Clear content when uploading file
      }));
      setMessage(`Documento "${title}" caricato con successo!`);
      setMessageType('success');
    } catch (error) {
      console.error(`Errore durante il caricamento del documento ${title}:`, error);
      setMessage(`Errore durante il caricamento del documento "${title}".`);
      setMessageType('danger');
    } finally {
      setLegalDocuments(prevDocs => ({ ...prevDocs, [documentType]: { ...docState, uploadLoading: false } }));
    }
  };

  const handleLegalDocumentDownload = (documentType) => {
    const docState = legalDocuments[documentType];
    if (docState.metadata && docState.metadata.file_url_for_display) {
      window.open(docState.metadata.file_url_for_display, '_blank');
    } else {
      alert('Nessun documento disponibile per la visualizzazione/download.');
    }
  };

  // Stessa card (testo o file) per ogni tipo di documento legale, usata sia dal
  // negozio (piu' tipi) sia dal tab riversamenti (un tipo solo).
  const renderDocumentoLegale = (documentType, title) => {
    const docState = legalDocuments[documentType];
    return (
      <div key={documentType} className="mb-4 p-3 border rounded">
        <h5>{title}</h5>
        <Tab.Container defaultActiveKey="content">
          <Nav variant="pills" className="mb-3">
            <Nav.Item><Nav.Link eventKey="content">Modifica Testo</Nav.Link></Nav.Item>
            <Nav.Item><Nav.Link eventKey="file">Carica File</Nav.Link></Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="content">
              <Form.Group className="mb-2">
                <Form.Label>Contenuto HTML</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={15}
                  placeholder={`Inserisci qui il contenuto HTML per ${title}`}
                  value={docState.content}
                  onChange={(e) => handleLegalDocContentChange(documentType, e.target.value)}
                  disabled={docState.uploadLoading}
                />
              </Form.Group>
              <Button
                variant="primary"
                onClick={() => handleLegalDocumentContentSave(documentType, title)}
                disabled={docState.uploadLoading}
              >
                {docState.uploadLoading ? 'Salvataggio...' : 'Salva Testo'}
              </Button>
            </Tab.Pane>
            <Tab.Pane eventKey="file">
               <p className="text-muted">
                  {docState.metadata && docState.metadata.original_filename ?
                    <>File corrente: <strong>{docState.metadata.original_filename}</strong> (Agg. {new Date(docState.metadata.updated_at).toLocaleDateString()})</>
                    : "Nessun file caricato."
                  }
               </p>
              <Form.Group className="mb-2">
                <Form.Label>Carica nuovo documento</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => handleLegalDocumentFileChange(documentType, e)}
                  disabled={docState.uploadLoading}
                />
              </Form.Group>
              <div className="d-flex justify-content-start">
                <Button
                  variant="success"
                  onClick={() => handleLegalDocumentUpload(documentType, title)}
                  disabled={!docState.file || docState.uploadLoading}
                  className="me-2"
                >
                  {docState.uploadLoading ? 'Caricamento...' : 'Carica File'}
                </Button>
                <Button
                  variant="info"
                  onClick={() => handleLegalDocumentDownload(documentType)}
                  disabled={!docState.metadata || !docState.metadata.file_path}
                >
                  Visualizza/Scarica
                </Button>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === 'prossimoNumeroFattura' ? parseInt(value, 10) || 1 : value;
    setFormData(prevData => ({
      ...prevData,
      [name]: newValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');

    try {
        const apiFormData = new FormData();
        const dataToSend = {};
        for (const key in formData) {
                if (formData[key] !== null && formData[key] !== undefined) {
                    const backendKey = {
                        fraseDelGiorno: 'frase_del_giorno',
                        fraseDelGiornoFont: 'frase_del_giorno_font',
                        regImprese: 'reg_imprese',
                        homePage: 'home_page',
                        logoUrl: 'logo_url',
                        logoRiversamentiUrl: 'logo_riversamenti_url',
                        emailOrdini: 'email_ordini',
                        emailReclami: 'email_reclami',
                        orariApertura: 'orari_apertura',
                        prossimoNumeroFattura: 'prossimo_numero_fattura',
                        facebookUrl: 'facebook_url',
                        instagramUrl: 'instagram_url',
                        dataInizioChiusura: 'data_inizio_chiusura',
                        dataFineChiusura: 'data_fine_chiusura',
                        messaggioChiusura: 'messaggio_chiusura'
                    }[key] || key;
                    // Le date vuote vanno mandate come null, non come stringa vuota (Pydantic date)
                    const isDateField = key === 'dataInizioChiusura' || key === 'dataFineChiusura';
                    dataToSend[backendKey] = (isDateField && formData[key] === '') ? null : formData[key];
                }
            }
            apiFormData.append('data', JSON.stringify(dataToSend));
        
            if (logoFile) {
                apiFormData.append('logo_file', logoFile);
            }

            if (logoRivFile) {
                apiFormData.append('logo_riversamenti_file', logoRivFile);
            }
            
            const response = await api.put('/dati-azienda/', apiFormData, {            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        setMessage('Dati azienda salvati con successo!');
        setMessageType('success');
        
        const updatedData = {
          ...formData,
          id: response.data.id,
          logoUrl: response.data.logo_url,
          logoRiversamentiUrl: response.data.logo_riversamenti_url,
          prossimoNumeroFattura: response.data.prossimo_numero_fattura,
        };
        setFormData(updatedData);
        const STATIC_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        if (response.data.logo_url) {
            setLogoPreview(`${STATIC_URL}${response.data.logo_url}?t=${new Date().getTime()}`);
        }
        if (response.data.logo_riversamenti_url) {
            setLogoRivPreview(`${STATIC_URL}${response.data.logo_riversamenti_url}?t=${new Date().getTime()}`);
        }

        window.dispatchEvent(new CustomEvent('datiAziendaUpdated'));
    } catch (error) {
        console.error('Errore durante il salvataggio dei dati azienda:', error);
        setMessage('Errore durante il salvataggio dei dati aziendali.');
        setMessageType('danger');
    }
  };

  useEffect(() => {
    const fetchDatiAzienda = async () => {
      try {
        const response = await getDatiAzienda();
        const fetchedData = {
          id: response.data.id || null,
          denominazione: response.data.denominazione || '',
          indirizzo: response.data.indirizzo || '',
          cap: response.data.cap || '',
          citta: response.data.citta || '',
          provincia: response.data.provincia || '',
          nazione: response.data.nazione || '',
          piva: response.data.piva || '',
          regImprese: response.data.reg_imprese || '',
          tel: response.data.tel || '',
          cell: response.data.cell || '',
          email: response.data.email || '',
          emailOrdini: response.data.email_ordini || '',
          emailReclami: response.data.email_reclami || '',
          pec: response.data.pec || '',
          homePage: response.data.home_page || '',
          logoUrl: response.data.logo_url || '',
          logoRiversamentiUrl: response.data.logo_riversamenti_url || '',
          fraseDelGiorno: response.data.frase_del_giorno || '',
          fraseDelGiornoFont: response.data.frase_del_giorno_font || 'Arial',
          orariApertura: response.data.orari_apertura || '',
          prossimoNumeroFattura: response.data.prossimo_numero_fattura || 1,
          facebookUrl: response.data.facebook_url || '',
          instagramUrl: response.data.instagram_url || '',
          dataInizioChiusura: response.data.data_inizio_chiusura || '',
          dataFineChiusura: response.data.data_fine_chiusura || '',
          messaggioChiusura: response.data.messaggio_chiusura || '',
        };
        setFormData(fetchedData);
        const STATIC_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        if (fetchedData.logoUrl) {
          setLogoPreview(`${STATIC_URL}${fetchedData.logoUrl}?t=${new Date().getTime()}`);
        }
        if (fetchedData.logoRiversamentiUrl) {
          setLogoRivPreview(`${STATIC_URL}${fetchedData.logoRiversamentiUrl}?t=${new Date().getTime()}`);
        }
      } catch (error) {
        if (!error.response || error.response.status !== 404) {
          console.error('Errore durante il recupero dei dati azienda:', error);
          setMessage('Errore durante il recupero dei dati aziendali.');
          setMessageType('danger');
        }
      }
    };

    fetchDatiAzienda();
    fetchLegalDocuments();
  }, []);

  return (
    <Container className="mt-4">
      <Row className="justify-content-md-center">
        <Col md={10}>
          <h2>Dati Azienda</h2>
          {message && <Alert variant={messageType}>{message}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Tab.Container defaultActiveKey={tabIniziale}>
              <Nav variant="tabs" className="mb-4">
                <Nav.Item><Nav.Link eventKey="modenacinema">ModenaCinema</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="riversamenti">ModenaRiversamenti</Nav.Link></Nav.Item>
              </Nav>
              <Tab.Content>
              <Tab.Pane eventKey="modenacinema">
             {/* Cards for Dati Anagrafici, Fiscali, etc. remain unchanged */}
            <Card className="mb-4">
              <Card.Header as="h5">Logo Aziendale</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3" controlId="formLogo">
                  <Form.Label>Carica Logo</Form.Label>
                  <Form.Control type="file" accept="image/png, image/jpeg" onChange={handleFileChange} />
                </Form.Group>
                {logoPreview && <div className="mt-3"><p>Anteprima:</p><Image src={logoPreview} thumbnail style={{ maxHeight: '150px' }} /></div>}
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Dati Anagrafici</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3" controlId="formDenominazione"><Form.Label>Denominazione</Form.Label><Form.Control type="text" placeholder="Inserisci la denominazione" name="denominazione" value={formData.denominazione} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formIndirizzo"><Form.Label>Indirizzo</Form.Label><Form.Control type="text" placeholder="Inserisci l'indirizzo" name="indirizzo" value={formData.indirizzo} onChange={handleChange} /></Form.Group>
                <Row>
                  <Col md={4}><Form.Group className="mb-3" controlId="formCap"><Form.Label>CAP</Form.Label><Form.Control type="text" placeholder="CAP" name="cap" value={formData.cap} onChange={handleChange} /></Form.Group></Col>
                  <Col md={4}><Form.Group className="mb-3" controlId="formCitta"><Form.Label>Città</Form.Label><Form.Control type="text" placeholder="Città" name="citta" value={formData.citta} onChange={handleChange} /></Form.Group></Col>
                  <Col md={4}><Form.Group className="mb-3" controlId="formProvincia"><Form.Label>Provincia</Form.Label><Form.Control type="text" placeholder="Provincia" name="provincia" value={formData.provincia} onChange={handleChange} /></Form.Group></Col>
                </Row>
                <Form.Group className="mb-3" controlId="formNazione"><Form.Label>Nazione</Form.Label><Form.Control type="text" placeholder="Nazione" name="nazione" value={formData.nazione} onChange={handleChange} /></Form.Group>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Dati Fiscali</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3" controlId="formPiva"><Form.Label>P.IVA</Form.Label><Form.Control type="text" placeholder="Partita IVA" name="piva" value={formData.piva} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formRegImprese"><Form.Label>Reg. Imprese</Form.Label><Form.Control type="text" placeholder="Registro Imprese" name="regImprese" value={formData.regImprese} onChange={handleChange} /></Form.Group>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Contatti</Card.Header>
              <Card.Body>
                <Row>
                  <Col md={6}><Form.Group className="mb-3" controlId="formTel"><Form.Label>Tel.</Form.Label><Form.Control type="text" placeholder="Telefono" name="tel" value={formData.tel} onChange={handleChange} /></Form.Group></Col>
                  <Col md={6}><Form.Group className="mb-3" controlId="formCell"><Form.Label>Cell.</Form.Label><Form.Control type="text" placeholder="Cellulare" name="cell" value={formData.cell} onChange={handleChange} /></Form.Group></Col>
                </Row>
                <Form.Group className="mb-3" controlId="formEmail"><Form.Label>Email Generale</Form.Label><Form.Control type="email" placeholder="Email" name="email" value={formData.email} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formEmailOrdini"><Form.Label>Email Ordini</Form.Label><Form.Control type="email" placeholder="Email per informazioni ordini" name="emailOrdini" value={formData.emailOrdini} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formEmailReclami"><Form.Label>Email Reclami</Form.Label><Form.Control type="email" placeholder="Email per reclami" name="emailReclami" value={formData.emailReclami} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formPec"><Form.Label>PEC</Form.Label><Form.Control type="email" placeholder="PEC" name="pec" value={formData.pec} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formHomePage"><Form.Label>Home Page</Form.Label><Form.Control type="url" placeholder="URL Home Page" name="homePage" value={formData.homePage} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formFacebookUrl"><Form.Label>Facebook URL</Form.Label><Form.Control type="url" placeholder="https://facebook.com/tuapagina" name="facebookUrl" value={formData.facebookUrl} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formInstagramUrl"><Form.Label>Instagram URL</Form.Label><Form.Control type="url" placeholder="https://instagram.com/tuoprofilo" name="instagramUrl" value={formData.instagramUrl} onChange={handleChange} /></Form.Group>
                <Form.Group className="mb-3" controlId="formOrariApertura"><Form.Label>Orari Apertura</Form.Label><Form.Control as="textarea" rows={3} placeholder="Es: Lunedì - Venerdì: 9:00 - 12:30 / 14:30 - 18:00" name="orariApertura" value={formData.orariApertura} onChange={handleChange} /></Form.Group>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Impostazioni Fatturazione</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3" controlId="formProssimoNumeroFattura">
                  <Form.Label>Prossimo Numero Fattura</Form.Label>
                  <Form.Control type="number" placeholder="Inserisci il prossimo numero di fattura" name="prossimoNumeroFattura" value={formData.prossimoNumeroFattura} onChange={handleChange} min="1" />
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Chiusura per Ferie</Card.Header>
              <Card.Body>
                <p className="text-muted small">
                  Se impostato, durante questo periodo il sito mostra un banner e le mail di conferma ordine
                  avvisano che la spedizione partirà dalla data di fine. Il negozio resta aperto: gli ordini
                  vengono comunque accettati.
                </p>
                <Row>
                  <Col md={6}><Form.Group className="mb-3" controlId="formDataInizioChiusura"><Form.Label>Dal</Form.Label><Form.Control type="date" name="dataInizioChiusura" value={formData.dataInizioChiusura} onChange={handleChange} /></Form.Group></Col>
                  <Col md={6}><Form.Group className="mb-3" controlId="formDataFineChiusura"><Form.Label>Al (ripresa spedizioni)</Form.Label><Form.Control type="date" name="dataFineChiusura" value={formData.dataFineChiusura} onChange={handleChange} /></Form.Group></Col>
                </Row>
                <Form.Group className="mb-3" controlId="formMessaggioChiusura">
                  <Form.Label>Messaggio personalizzato (opzionale)</Form.Label>
                  <Form.Control as="textarea" rows={2} placeholder="Se vuoto viene usato un testo standard con la data di ripresa" name="messaggioChiusura" value={formData.messaggioChiusura} onChange={handleChange} />
                  <Form.Text className="text-muted">
                    La data di ripresa (sopra) viene aggiunta automaticamente in fondo al messaggio.
                    Per metterla in un punto preciso della frase, scrivi <code>{'{data}'}</code> dove deve comparire.
                  </Form.Text>
                </Form.Group>
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Documenti Legali</Card.Header>
              <Card.Body>
                {Object.entries(LEGAL_DOCUMENT_TYPES).map(([key, documentType]) =>
                  renderDocumentoLegale(documentType, key.replace(/_/g, ' '))
                )}
              </Card.Body>
            </Card>

            <Card className="mb-4">
              <Card.Header as="h5">Frase del Giorno</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3" controlId="formFraseDelGiorno"><Form.Label>Frase del Giorno</Form.Label><Form.Control type="text" placeholder="Inserisci la frase del giorno" name="fraseDelGiorno" value={formData.fraseDelGiorno} onChange={handleChange} style={{ fontFamily: formData.fraseDelGiornoFont }} /></Form.Group>
                <Form.Group className="mb-3" controlId="formFraseDelGiornoFont"><Form.Label>Font Frase del Giorno</Form.Label><Form.Select name="fraseDelGiornoFont" value={formData.fraseDelGiornoFont} onChange={handleChange}><option value="Arial">Arial</option><option value="Verdana">Verdana</option><option value="Helvetica">Helvetica</option><option value="Times New Roman">Times New Roman</option><option value="Georgia">Georgia</option><option value="Courier New">Courier New</option><option value="Lucida Console">Lucida Console</option></Form.Select></Form.Group>
              </Card.Body>
            </Card>

              </Tab.Pane>

              <Tab.Pane eventKey="riversamenti">
                <Card className="mb-4">
                  <Card.Header as="h5">Logo modenariversamenti.it</Card.Header>
                  <Card.Body>
                    <p className="text-muted">
                      Logo del sito dei riversamenti, indipendente da quello di ModenaCinema.
                      Compare in alto a sinistra nell&apos;header, con sotto la scritta
                      &laquo;a company of ModenaCinema dal 1999&raquo;.
                    </p>
                    <Form.Group className="mb-3" controlId="formLogoRiversamenti">
                      <Form.Label>Carica logo</Form.Label>
                      <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleRivFileChange} />
                      <Form.Text className="text-muted">
                        PNG con sfondo trasparente consigliato: l&apos;header ha lo sfondo blu.
                        Altezza di resa 80px, quindi serve un&apos;immagine alta almeno 160px.
                      </Form.Text>
                    </Form.Group>
                    {logoRivPreview ? (
                      <div className="mt-3">
                        <p>Anteprima su sfondo header:</p>
                        <div className="d-inline-block p-3 rounded" style={{ backgroundColor: '#284d95' }}>
                          <Image src={logoRivPreview} style={{ maxHeight: '80px' }} />
                          <div className="text-white" style={{ fontSize: '11px', marginTop: '2px' }}>
                            a company of ModenaCinema dal 1999
                          </div>
                        </div>
                      </div>
                    ) : (
                      <Alert variant="warning" className="mb-0">
                        Nessun logo caricato: il sito riversamenti mostra il nome scritto in
                        testo al posto dell&apos;immagine.
                      </Alert>
                    )}
                  </Card.Body>
                </Card>

                <Card className="mb-4">
                  <Card.Header as="h5">Documenti Legali</Card.Header>
                  <Card.Body>
                    <p className="text-muted">
                      Il form preventivo di modenariversamenti.it raccoglie dati diversi (nome,
                      email, telefono, note) da quelli del negozio: ha una sua informativa privacy,
                      separata da quella del negozio qui sopra.
                    </p>
                    {renderDocumentoLegale('privacy_policy_riversamenti', 'PRIVACY POLICY RIVERSAMENTI')}
                  </Card.Body>
                </Card>
              </Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            <Button variant="primary" type="submit" className="mb-4">Salva Dati Azienda</Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
export default DatiAzienda;